function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Courses",
  stroke: "none",
  strokeWidth: 1,
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Edit-Course-Effort",
  transform: "translate(-25.000000, -530.000000)"
}, React.createElement("path", {
  d: "M33.7272727,533.636364 L33.7272727,532.181818 L33.7272727,531.496727 L33.7272727,530.046545 C33.4865455,530.024727 33.2465455,530 33,530 C28.5890909,530 25,533.588364 25,538 C25,542.410182 28.5890909,546 33,546 C37.4109091,546 41,542.410182 41,538 C41,535.530182 39.8749091,533.320727 38.112,531.852364 L37.0763636,532.888727 C37.0778182,532.889455 37.0785455,532.890909 37.0792727,532.891636 L32.4858182,537.485091 L33.5141818,538.514182 L38.1083636,533.919273 C38.8632727,534.861091 39.3629091,536.012364 39.5025455,537.272727 L37.3636364,537.272727 L37.3636364,538.727273 L39.5025455,538.727273 C39.1665455,541.754909 36.7563636,544.165818 33.7272727,544.501818 L33.7272727,542.397091 L32.2727273,542.397091 L32.2727273,544.501818 C29.2436364,544.165818 26.8334545,541.754909 26.4974545,538.727273 L28.6014545,538.727273 L28.6014545,537.272727 L26.4989091,537.272727 C26.8356364,534.243636 29.2443636,531.833455 32.2727273,531.496727 L32.2727273,533.636364 L33.7272727,533.636364 Z",
  id: "Fill-1"
})));

var SvgIconCourseEffort = function SvgIconCourseEffort(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconCourseEffort, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-course-effort.59aa1014.svg";
export { ForwardRef as ReactComponent };